import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import CustomControl from '../../global/CustomControl';
import Badge from '../../global/Badge';
import { getUniformTagLabel } from '../../../util/album-folder-tags';
import ShirtIcon from '../../icons/ShirtIcon';
import { ALBUM_FOLDER_TAG_TYPE } from '../../../constants/album-folder-tags';
import Button from '../../global/Button';

class AlbumFolderPurchaseSelectableTag extends Component {
  static propTypes = {
    tag: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.oneOf(Object.keys(ALBUM_FOLDER_TAG_TYPE)),
      uniform_enabled: PropTypes.bool,
      uniform_numbered: PropTypes.bool,
      levels: PropTypes.shape({
        records: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
          }),
        ),
      }),
    }),
    onTagSelected: PropTypes.func.isRequired,
    isSelected: PropTypes.bool,
    metadata: PropTypes.shape({
      jerseyNumber: PropTypes.string,
      levelId: PropTypes.string,
      teamId: PropTypes.string,
    }),
    onEditTag: PropTypes.func.isRequired,
    subscriptionTag: PropTypes.object,
  };

  render() {
    const {
      tag,
      isSelected,
      onTagSelected,
      metadata,
      onEditTag,
      subscriptionTag,
    } = this.props;

    const uniformEnabled = tag?.uniform_enabled;
    const hasLevels = tag?.levels?.records?.length > 0;

    const { levelId, teamId } = metadata ?? {};
    const level = (tag?.levels?.records ?? []).find(l => l.id === levelId);
    const team = (level?.teams?.records ?? []).find(t => t.id === teamId);

    return (
      <Fragment>
        <a
          href="#"
          className="flex-list-item ml-2 flex-column justify-content-center"
          onClick={event => {
            event.preventDefault();
            if (subscriptionTag) {
              return;
            }

            onTagSelected(tag);
          }}
        >
          <div className="d-flex w-100">
            <span className="text-dark mr-1">{getUniformTagLabel(tag)}</span>
            <div className="ml-auto d-flex text-right">
              {subscriptionTag ? (
                <Fragment>
                  {uniformEnabled || hasLevels ? (
                    <Button
                      className="m-auto"
                      onClick={event => {
                        event.stopPropagation();
                        onEditTag();
                      }}
                      btnStyle="reset"
                    >
                      <Badge badgeStyle="primary">Edit</Badge>
                    </Button>
                  ) : (
                    <span className="text-color-base text-sm">Subscribed</span>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  {metadata && onEditTag && (
                    <Button
                      className="mr-1"
                      onClick={event => {
                        event.stopPropagation();
                        onEditTag();
                      }}
                      btnStyle="reset"
                    >
                      <Badge badgeStyle="secondary">Edit</Badge>
                    </Button>
                  )}
                  <CustomControl
                    id={tag.id}
                    type="checkbox"
                    checked={isSelected}
                    readOnly
                    className="m-0"
                  />
                </Fragment>
              )}
            </div>
          </div>
          {metadata && (
            <div className="d-flex w-100">
              {metadata.jerseyNumber && (
                <Badge badgeStyle="secondary" badgeSize="sm" className="mr-1">
                  <ShirtIcon /> {metadata.jerseyNumber}
                </Badge>
              )}
              {level && (
                <Badge badgeStyle="secondary" badgeSize="sm" className="mr-1">
                  {level.name}
                </Badge>
              )}
              {team && (
                <Badge badgeStyle="secondary" badgeSize="sm">
                  {team.name}
                </Badge>
              )}
            </div>
          )}
        </a>
      </Fragment>
    );
  }
}

export default AlbumFolderPurchaseSelectableTag;
